import type { ReactNode } from 'react'

interface CardProps {
  children: ReactNode
  className?: string
  padding?: 'none' | 'sm' | 'md' | 'lg'
  elevated?: boolean
}

export default function Card({ children, className = '', padding = 'md', elevated = false }: CardProps) {
  const pad = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-6',
  }[padding]

  return (
    <div
      className={`rounded-2xl border border-ica-border bg-ica-surface ${elevated ? 'bg-ica-elevated' : ''} ${pad} ${className}`}
    >
      {children}
    </div>
  )
}
